import apiClient from '../../../services/api-client'
import type { SurveyResponseItem, SurveyStats, SurveyResponseConstraint } from '../types/survey.types'

interface SurveyResponseListResponse {
  data: SurveyResponseItem[]
}

export async function listSurveyResponses(constraint?: SurveyResponseConstraint): Promise<SurveyResponseItem[]> {
  const response = await apiClient.get<SurveyResponseListResponse>('/survey-response', {
    params: constraint
  })
  return response.data.data
}

export async function getSurveyStats(surveyId: string): Promise<SurveyStats> {
  const response = await apiClient.get<SurveyStats>('/survey-response/stats', {
    params: { surveyId }
  })
  return response.data
}
